export const api = {
    appointApproval: {
        queryAppointApprovalList: '/bms/vehicle/appointment/page.json', // 查询预约审批列表
        approvalExamine: '/bms/vehicle/appointment/dispatchExamine.json', // 审核未通过 通过status -- 2
        isExistedAppointment: '/bms/vehicle/appointment/isExistedAppointment?appointmentUuid=', // 是否存在相同司机姓名、电话、货品、柜号预约记录单
    },
    exitApproval: {
        dispatchOutExamine: '/bms/vehicle/appointment/dispatchOutExamine.json', // [调度出园审批] 不押车放行(8)、解押车放行(8)
        dispatchOutPauseCar: '/bms/vehicle/appointment/dispatchOutPauseCar.json', // [调度出园审批] 押车不放行(11)
    }
}
